import { render, staticRenderFns } from "./myBought.vue?vue&type=template&id=382d13c0&scoped=true"
import script from "./myBought.vue?vue&type=script&lang=js"
export * from "./myBought.vue?vue&type=script&lang=js"
import style0 from "./myBought.vue?vue&type=style&index=0&id=382d13c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382d13c0",
  null
  
)

export default component.exports